/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lastseenlongago3Inputs */



/**
* | output |
* | --- |
* | "last seen: long ago" |
*
* @param {Lastseenlongago3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const lastseenlongago3 = /** @type {((inputs?: Lastseenlongago3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lastseenlongago3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("last seen: long ago")
	if (locale === "es") return /** @type {LocalizedString} */ ("últ. vez: hace mucho")
	return /** @type {LocalizedString} */ ("в сети: давно")
});
export { lastseenlongago3 as "lastSeenLongAgo" }